import React,{useState} from "react";
import  {useLocation as location2} from "wouter";
import Alert from "../components/Alert";
import Loading from "../components/Loading";
import post from '../post';
import * as Constants from '../constants';
const Register = () => {
    const [location, navigate] = location2();
    const [alert, setAlert] = useState({ isOpen: false, title: '', message: '' });
    const [loading, setLoading] = useState(false);

    const user_id = localStorage.getItem('token');
    const startRegister = async () => {
        //validate all fields are not empty after trim, additionaly validate email format and password match
        const name = document.getElementById('name').value.trim();
        const email = document.getElementById('email').value.trim();
        const telephone = document.getElementById('telephone').value.trim();
        const password = document.getElementById('password').value.trim();
        const confirmPassword = document.getElementById('confirm-password').value.trim();
        const terms = document.getElementById('terms').checked;
        if (!name || !email || !telephone || !password || !confirmPassword) {
            setAlert({ isOpen: true, title: 'Error', message: 'Por favor, completa todos los campos.' });
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setAlert({ isOpen: true, title: 'Error', message: 'Por favor, ingresa un correo electrónico válido.' });
            return;
        }
        if(telephone.length!=10){
            setAlert({ isOpen: true, title: 'Error', message: 'Por favor, ingresa un número de teléfono válido a 10 dígitos.' });
            return;
        }
        if (password !== confirmPassword) {
            setAlert({ isOpen: true, title: 'Error', message: 'Las contraseñas no coinciden.' });
            return;
        }if(password.length<6){
            setAlert({ isOpen: true, title: 'Error', message: 'La contraseña debe tener al menos 6 caracteres.' });
            return;
        }

        if (!terms) {
            setAlert({ isOpen: true, title: 'Error', message: 'Debes aceptar los términos y condiciones.' });
            return;
        }
        //if all good, proceed to register
        setLoading(true);
        //generate long random token:
        const token=btoa(Array(30).fill(null).map(() => Math.random().toString(36).charAt(2)).join(''));
        
        const response = await post('register',{
            nombre:name,
            email:email,
            telefono:telephone,
            pass:password,
            token:token
        },false);
        setLoading(false);
        if(!response.result){
            setAlert({ isOpen: true, title: 'Error', message: response.motive??'Error al registrar. Intenta de nuevo.' });
            return;
        }
        localStorage.setItem('token', token);
        navigate('/');
    }
    if (user_id) {
        navigate('/');
    }
    return (
        <div id="webcrumbs">
           <Alert isOpen={alert.isOpen} title={alert.title} message={alert.message} onClose={() => setAlert({ isOpen: false, title: '', message: '' })} />
            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center">
            <Loading isOpen={loading} />
                

                <div className="w-full max-w-md px-6 py-10">
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-40 h-40 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg">
                            <img src={Constants.LOGO_URL} alt="Logo"  className="" />
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">{Constants.BUSINESS_NAME}</h1>
                        <p className="text-neutral-600 text-center">
                            Crea una cuenta para disfrutar de todos nuestros servicios.
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-6 mb-6 backdrop-blur-sm">
                        <form className="space-y-4">
                            <div className="space-y-2">
                                <label htmlFor="name" className="block text-sm font-medium text-neutral-700">
                                    Nombre completo
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">person</span>
                                    </span>
                                    <input
                                        type="text"
                                        id="name"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="Juan Pérez"
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="email" className="block text-sm font-medium text-neutral-700">
                                    Correo electrónico
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">mail</span>
                                    </span>
                                    <input
                                        type="email"
                                        id="email"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="usuario@ejemplo.com"
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="telephone" className="block text-sm font-medium text-neutral-700">
                                    Teléfono
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">phone</span>
                                    </span>
                                    <input
                                        type="tel"
                                        id="telephone"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        onKeyUp={(e) => {
                                            const cleaned = e.target.value.replace(/\D/g, '');
                                            e.target.value = cleaned;
                                        }}
                                        placeholder="5512345678"
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="password" className="block text-sm font-medium text-neutral-700">
                                    Contraseña
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">lock</span>
                                    </span>
                                    <input
                                        type="password"
                                        id="password"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="********"
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label
                                    htmlFor="confirm-password"
                                    className="block text-sm font-medium text-neutral-700"
                                >
                                    Confirmar contraseña
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">verified</span>
                                    </span>
                                    <input
                                        type="password"
                                        id="confirm-password"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="********"
                                    />
                                </div>
                            </div>

                            <div className="flex items-start mt-4">
                                <div className="flex items-center h-5">
                                    <input
                                        id="terms"
                                        type="checkbox"
                                        className="w-4 h-4 text-primary-600 border-neutral-300 rounded focus:ring-primary-500"
                                    />
                                </div>
                                <div className="ml-3 text-sm">
                                    <label htmlFor="terms" className="text-neutral-600">
                                        Acepto los{" "}
                                        <a href="#" className="text-primary-600 hover:underline">
                                            Términos y condiciones
                                        </a>{" "}
                                        y la{" "}
                                        <a href="#" className="text-primary-600 hover:underline">
                                            Política de privacidad
                                        </a>
                                    </label>
                                </div>
                            </div>

                            <button
                                type="button"
                                onClick={startRegister}
                                className="w-full bg-primary-600 text-white py-3.5 rounded-xl font-medium shadow-sm hover:bg-primary-700 transition-all transform hover:scale-[1.01] active:scale-[0.99] mt-2"
                                disabled={loading}
                            >
                                Crear cuenta
                            </button>
                        </form>

                        {/*<div className="relative flex items-center my-6">
                            <div className="flex-grow border-t border-neutral-200"></div>
                            <span className="flex-shrink mx-4 text-neutral-400 text-sm">o regístrate con</span>
                            <div className="flex-grow border-t border-neutral-200"></div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <button className="flex items-center justify-center gap-2 py-3 border border-neutral-200 rounded-xl font-medium hover:bg-neutral-50 transition-colors">
                                <img
                                    src="https://img.icons8.com/color/24/null/google-logo.png"
                                    alt="Google logo"
                                    className="w-5 h-5"
                                />
                                <span className="text-neutral-700">Google</span>
                            </button>
                            <button className="flex items-center justify-center gap-2 py-3 border border-neutral-200 rounded-xl font-medium hover:bg-neutral-50 transition-colors">
                                <img
                                    src="https://images.unsplash.com/photo-1714251033127-9401d0adaaac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MzkyNDZ8MHwxfHNlYXJjaHwxfHxhcHBsZSUyMGxvZ298ZW58MHx8fHwxNzU2ODQxODU3fDA&ixlib=rb-4.1.0&q=80&w=1080"
                                    alt="Apple logo"
                                    className="w-5 h-5"
                                />
                                <span className="text-neutral-700">Apple</span>
                            </button>
                        </div>*/}
                    </div>

                    <div className="text-center">
                        <p className="text-neutral-600">
                            ¿Ya tienes una cuenta?{" "}
                            <a
                                href="/login"
                                className="text-primary-600 font-medium hover:text-primary-700 transition-colors"
                            >
                                Inicia sesión
                            </a>
                        </p>
                    </div>

                    <div></div>
                </div>
            </div>
        </div>
    )
}


export default Register;